export interface EventAbiInput {
  name: string;
  type: string;
  indexed?: boolean;
  internalType?: string;
}

export interface EventAbi {
  name: string;
  type: string;
  inputs: EventAbiInput[];
  anonymous?: boolean;
}

/**
 * Parse an event ABI from a trigger payload field.
 * Handles stringified JSON, arrays (picks first), and plain objects.
 */
export function parseEventAbiFromPayload(raw: unknown): {
  eventAbi: EventAbi | undefined;
  eventName: string | undefined;
} {
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (Array.isArray(parsed) && parsed[0]?.name) {
      return { eventAbi: parsed[0], eventName: parsed[0].name };
    }
    if (parsed?.name) {
      return { eventAbi: parsed, eventName: parsed.name };
    }
  } catch {
    // ignore parse errors
  }
  return { eventAbi: undefined, eventName: undefined };
}
